import React from 'react';

import './QuickJobSearch.css';

const QuickJobSearch = () => {
  return (
    <div className="quick-job-search">
      <div className="container">
        <h1>
          Join <span className="text-primary">our team</span>
        </h1>
        <p>
          NATEK delivers projects worldwide from the CEE region. Join NATEK and become a part of community where you can thrive and grow your career in IT. Our Team is our most valuable asset and our
          goal is to inspire each other to reach our full potential.
        </p>
        <h2>Ready to apply?</h2>
        <div className="form-wrapper">
          <form className="row g-3" onSubmit={(e) => e.preventDefault()}>
            <div className="col-12 col-md-4 col-lg-6">
              <input type="text" className="form-control form-control-lg" placeholder="position, company, key word..." />
            </div>
            <div className="col-12 col-md-4 col-lg-4">
              <input className="form-control form-control-lg" list="datalistOptions" placeholder="desired location..." />
              <datalist id="datalistOptions">
                <option value="Warsaw"></option>
                <option value="Wrocław"></option>
                <option value="Prague"></option>
                <option value="Brno"></option>
                <option value="Autocomplition..."></option>
              </datalist>
            </div>
            <div className="col-12 col-md-4 col-lg-2">
              <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>
                Search
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default QuickJobSearch;
